import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Button, Typography, Box, Link } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { GET_HODA_INFO, USERS_API } from "../api";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import { useDispatch } from "react-redux";
import { addErrorMessage, addNewMessage } from "../slice";
import Input from "../components/Input";
import Footer from "./Footer";
import { ArcaptchaWidget } from "arcaptcha-react";

function SignUp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const recaptcha = useRef();
  const [captchaToken, setCaptchaToken] = useState();
  const [captchaKey, setCaptchaKey] = useState();
  const [showErrors, setShowErrors] = useState({
    firstName: false,
    lastName: false,
    phoneNumber: false,
    password: false,
  });

  const { mutate: register } = useMutation((body) => USERS_API.Register(body), {
    onError: ({ response: { data } }) => {
      //todo: in qsmt byd payam haye smt server handle beshan
      dispatch(
        addNewMessage({
          id: "wrong-password",
          text: data.message,
          type: "error",
        }),
      );
      setCaptchaKey((prev) => prev + 1);
      setCaptchaToken(null);
      recaptcha.current.reset();
    },
    onSuccess: ({ data }) => {
      //todo:in qsmt ham byd payam haye smt server handle beshan
      navigate("/gender-determination");
    },
  });

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let body = {
      firstName: event.target.firstName.value,
      lastName: event.target.lastName.value,
      password: event.target.password.value,
    };
    if (
      String(event.target.userName.value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        ) !== null
    ) {
      body.email = event.target.userName.value;
      window.sessionStorage.setItem("email", body.email);
      window.sessionStorage.removeItem("phoneNumber");
      window.sessionStorage.setItem("action-type", "isByEmail");
      delete body.phoneNumber;
    } else if (
      String(event.target.userName.value).match(
        /((0?9)|(\+?989))((14)|(13)|(12)|(19)|(18)|(17)|(15)|(16)|(11)|(10)|(90)|(91)|(92)|(93)|(94)|(95)|(96)|(32)|(30)|(33)|(35)|(36)|(37)|(38)|(39)|(00)|(01)|(02)|(03)|(04)|(05)|(41)|(20)|(21)|(22)|(23)|(31)|(34)|(9910)|(9911)|(9913)|(9914)|(9999)|(999)|(990)|(9810)|(9811)|(9812)|(9813)|(9814)|(9815)|(9816)|(9817)|(998))\W?\d{3}\W?\d{4}/g,
      ) !== null
    ) {
      body.phoneNumber = event.target.userName.value;
      window.sessionStorage.setItem("phoneNumber", body.phoneNumber);
      window.sessionStorage.removeItem("email");
      window.sessionStorage.setItem("action-type", "isByPhoneNumber");
      delete body.email;
    }
    if (
      event.target.firstName?.value !== "" &&
      body.phoneNumber !== "" &&
      body.phoneNumber !== undefined &&
      event.target.lastName?.value !== "" &&
      event.target.password?.value !== ""
    ) {
      if (captchaToken) register({ ...body, captchaToken });
      else
        dispatch(
          addErrorMessage({ status: 400, data: { message: "لطفا من ربات نیستم را انتخاب کنید." } }),
        );
    } else {
      setShowErrors({
        firstName: body.firstName === "",
        phoneNumber: body.phoneNumber === "" || body.phoneNumber === undefined,
        lastName: body.lastName === "",
        password: body.password === "",
      });
    }
    //todo : in qsmt ham byd body validate beshe
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      position="relative"
    >
      <Box
        container
        xs={4}
        bgcolor="#fff"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        sx={{ boxSizing: "border-box" }}
        py={{ xs: 1, sm: 2, md: 4 }}
        px={{ xs: 1, sm: 4, md: 6 }}
        mt={3}
      >
        <Logo1 />
        <Typography variant="h1" mt={5} mb={2}>
          ثبت نام
        </Typography>
        <Typography variant="h2" my={1} textAlign="center">
          برای ثبت نام شماره تلفن خود را وارد کنید
        </Typography>
        <form
          onSubmit={handleSubmitForm}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            flexDirection="row-reverse"
            sx={{ width: "100%", maxWidth: "248px", alignItems: "center" }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Input
                placeholder="نام"
                type="text"
                name="firstName"
                flex={1}
                error={showErrors.firstName}
                onChange={() => setShowErrors({ ...showErrors, firstName: false })}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Input
                placeholder="نام خانوادگی"
                type="text"
                name="lastName"
                flex={1}
                error={showErrors.lastName}
                onChange={() => setShowErrors({ ...showErrors, lastName: false })}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Input
                placeholder="شماره تلفن"
                type="number"
                name="userName"
                flex={1}
                error={showErrors.phoneNumber}
                onChange={() => setShowErrors({ ...showErrors, phoneNumber: false })}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Input
                placeholder="رمزعبور"
                type="password"
                name="password"
                flex={1}
                error={showErrors.password}
                onChange={() => setShowErrors({ ...showErrors, password: false })}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              transform: "scale(0.85)",
            }}
          >
            <ArcaptchaWidget
              key={captchaKey}
              site-key="yxdswqtakz"
              ref={recaptcha}
              callback={(token) => {
                setCaptchaToken(token);
              }}
              hl="fa"
              onChange={(token) => {
                setCaptchaToken(token);
              }}
            />
          </Grid>
          <Button variant="l" sx={{ my: 2 }} type="submit">
            ثبت نام
          </Button>
        </form>
        <Box display="flex" alignItems="baseline">
          <Link href="/sign-in" underline="none" fontSize="14px" color="rgba(0, 0, 0, 0.6)" mr={1}>
            وارد شوید
          </Link>
          <Typography variant="h2" color="rgba(0, 0, 0, 0.6)">
            حساب کاربری دارید؟
          </Typography>
        </Box>
      </Box>
      <Footer />
    </Grid>
  );
}

const Style = {
  itemGrid: {
    boxSizing: "border-box",
    margin: "0.2rem 0px",
  },
};

export default SignUp;
